import { useEffect, useState } from "react";
import { apiGetHistory } from "../../services/apiServices";
import { useAuth } from "../../usermanagement/AuthProvider";
import { HistoryEntryTextDate } from "../../services/model";
import { Box, Grid, Typography } from "@mui/material";
import { formatDistance } from "date-fns";
import { useNavigate } from "react-router-dom";


export default function History() {
    const [history, setHistory] = useState<HistoryEntryTextDate[]>([]);

    const nav = useNavigate();

    const { defaultApiResponseChecks } = useAuth();

    useEffect(() => {
        apiGetHistory()
            .then(setHistory)
            .catch(err => {
                defaultApiResponseChecks(err);
            });
    }, [defaultApiResponseChecks])

    function fancyStringFromDate(date: Date) {
        try {
            return formatDistance(date, new Date()) + " ago";
        } catch (err) {
            console.log(err);
            return "1 hour ago";
        }
    }

    return (
        <Grid container direction={"column"}>
            {
                history?.map((h, i) =>
                    <Box key={i} mb={0.5} onClick={() => nav(`/h/${h.id}`)} sx={{ cursor: 'pointer' }}>
                        <Grid container direction={"row"} wrap={"nowrap"}>
                            <Grid ml={1} mr={1} size={4}>
                                <Typography color={"lightgray"}>
                                    {fancyStringFromDate(h.requestTime)}
                                </Typography>
                            </Grid>
                            <Grid border={1} borderRadius={5} size={7}>
                                <Typography ml={1} mr={1}>
                                    {h.text}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                )
            }
        </Grid>
    )
}